import type { FormikErrors } from "formik";
import type { ScheduleMilestoneForm } from "./scheduleMilestoneFormHelpers";

export type MilestoneRowErrors = Partial<
    Record<keyof ScheduleMilestoneForm, string>
>;

const ROW_FIELDS: ReadonlyArray<keyof ScheduleMilestoneForm> = [
    "name",
    "allocationPercent",
    "offsetCount",
    "offsetUnit",
    "anchor",
    "specificDate",
];

/** The row's message to show: its first field message in field order. */
export function pickMilestoneRowErrorMessage(
    errors: MilestoneRowErrors | undefined,
): string | undefined {
    if (errors === undefined) {
        return undefined;
    }
    return ROW_FIELDS.map((field) => errors[field]).find(
        (message) => message !== undefined,
    );
}

/** Each row's field messages, in row order, from Formik's nested errors. */
export function toMilestoneRowErrors(
    errors:
        | FormikErrors<ScheduleMilestoneForm[]>
        | string[]
        | string
        | undefined,
): Array<MilestoneRowErrors | undefined> {
    if (errors == null || typeof errors === "string") {
        return [];
    }
    return errors.map(
        (
            rowError: string | FormikErrors<ScheduleMilestoneForm> | undefined,
        ) => {
            if (rowError == null) {
                return undefined;
            }
            if (typeof rowError === "string") {
                return { name: rowError };
            }
            const rowErrors: MilestoneRowErrors = {};
            for (const field of ROW_FIELDS) {
                const message = rowError[field];
                if (typeof message === "string") {
                    rowErrors[field] = message;
                }
            }
            return rowErrors;
        },
    );
}
